import React from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@material-ui/core";
import Check from "@material-ui/icons/Check";
import { useIntl } from "react-intl";

import { useUsuario } from "../../../../hooks";
import { ActionButton } from "../../../../components";

ConcluirAtividadeButton.propTypes = {
  styleIcon: PropTypes.object,
  useIconWithLabel: PropTypes.bool,
  onClick: PropTypes.func,
  useJustLabel: PropTypes.bool,
  atividadeId: PropTypes.number,
  somenteConcluidas: PropTypes.bool,
};

function ConcluirAtividadeButton({
  styleIcon,
  useIconWithLabel = false,
  useJustLabel,
  atividadeId,
  somenteConcluidas,
  ...props
}) {
  const { isGerente } = useUsuario();
  const intl = useIntl();

  if (isGerente) return null;

  const renderActionButton = () => (
    <ActionButton
      id={atividadeId ? `btn-concluir-atividade-${atividadeId}` : "btn-concluir-atividade"}
      type={useJustLabel ? "text" : "menu"}
      onClick={() => props.onClick()}
      icon={!useJustLabel && <Check />}
      label={intl.formatMessage({ defaultMessage: "Concluir" })}
      disabled={somenteConcluidas}
      style={{ color: somenteConcluidas ? "rgba(0, 0, 0, 0.26)" : useJustLabel && "#fff" }}
    />
  );

  if (useIconWithLabel || useJustLabel) {
    if (somenteConcluidas)
      return (
        <Tooltip
          title={intl.formatMessage({
            defaultMessage: "As atividades selecionadas já estão concluídas",
          })}
        >
          <span>{renderActionButton()}</span>
        </Tooltip>
      );
    return renderActionButton();
  }

  return (
    <IconButton {...atividadeId && { id: `btn-concluir-atividade-${atividadeId}` }} {...props}>
      <Check style={styleIcon} />
    </IconButton>
  );
}

export default ConcluirAtividadeButton;
